<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3 pb-3">
  <section *ngIf="user" class="section-devider">
    <div class="col-12 col-sm-10 col-md-9 col-lg-6 col-xl-6 d-flex flex-row justify-content-between align-items-center pt-3 pb-2 pl-0">
      <h1 class="mr-2 mb-0">Organization info</h1>
      <button class="btn btn-outline-danger btn-delete-account" (click)="deleteAccount()">Delete account</button>
    </div>

    <div class="col-12 col-sm-10 col-md-9 col-lg-6 col-xl-6 pl-0 ml-0">
      <tablesready-organization-data [user]="user"></tablesready-organization-data>
    </div>
  </section>

  <section class="section-devider" *ngIf="user">
    <h1 class="pt-3 mb-3">Data retention</h1>

    <div class="col-12 col-sm-10 col-md-9 col-lg-6 col-xl-6 pl-0 ml-0">
      <p>
        Manage your account data retention policy. Select the number of days or months to retain your data as of the data creation date or your last login.
      </p>
      <tablesready-organization-data-retention [user]="user"></tablesready-organization-data-retention>
    </div>
  </section>

  <section *ngIf="user">
    <h1 class="pt-3 mb-3">Export data</h1>

    <div class="col-12 col-sm-10 col-md-9 col-lg-5 col-xl-4 pl-0 ml-0">
      <tablesready-export-data
        [user]="user.location"
        [locations]="locations"
        [isOnBusinessPlan]="hasBusinessPlanLocation"
        (freePlanDetected)="freePlanDetected()"
      ></tablesready-export-data>
    </div>
  </section>

  <section>
    <label class="control-label">History</label>

    <p class="d-flex flex-row align-items-center">
      <tr-icon [icon]="icon.infoHeavy" [size]="iconSize.small" classes="pr-2"></tr-icon>
      Exported files are retained for 3 days.
    </p>
    <tablesready-export-history
      [timezone]="user.location.timezone"
      [hasBusinessPlanLocation]="hasBusinessPlanLocation"
    ></tablesready-export-history>
  </section>

</section>
